import { IApiError } from '@frontend/request';

import { ILoginResponse } from '@aqx-core/common/api/auth';
import {
  ICentroidLoginMobileParams,
  ICentroidLoginWebParams,
  centroidLoginAPI
} from '@aqx-core/common/api/centroid-login';
import { IAPIControllerCallbacks } from '@aqx-core/common/api/types';

class CentroidLoginAPIController {
  public loginWebCentroidDemo = async (
    params: ICentroidLoginWebParams,
    callbacks: IAPIControllerCallbacks<ILoginResponse>
  ) => {
    try {
      const { result } = await centroidLoginAPI.loginWebCentroidDemo(params);
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };

  public loginMobileCentroidDemo = async (
    params: ICentroidLoginMobileParams,
    callbacks: IAPIControllerCallbacks<ILoginResponse>
  ) => {
    try {
      const { result } = await centroidLoginAPI.loginMobileCentroidDemo(params);
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    } finally {
      callbacks.onFinally?.();
    }
  };

  public loginWebCentroidLive = async (
    params: ICentroidLoginWebParams,
    callbacks: IAPIControllerCallbacks<ILoginResponse>
  ) => {
    try {
      const { result } = await centroidLoginAPI.loginWebCentroidLive(params);
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };

  public loginMobileCentroidLive = async (
    params: ICentroidLoginMobileParams,
    callbacks: IAPIControllerCallbacks<ILoginResponse>
  ) => {
    try {
      const { result } = await centroidLoginAPI.loginMobileCentroidLive(params);
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    } finally {
      callbacks.onFinally?.();
    }
  };
}

export const centroidLoginAPIController = new CentroidLoginAPIController();
